import * as React from "react";
import { createRoot } from "react-dom/client";
import type {
  GuidedProcessWindow,
  ProcessData,
} from "./guided-process/GuidedProcess.types.d.ts";
import GuidedProcessTool from "./guided-process/GuidedProcessTool";

declare var window: GuidedProcessWindow;

document.addEventListener("DOMContentLoaded", () => {
  const container = document.getElementById("guided-process") as HTMLDivElement;

  if (container) {
    const data: ProcessData = window.processData || {
      title: "",
      introContent: "",
      alertContent: "",
      finalStepContent: "",
      backLink: "",
      processMapLink: "",
      steps: [],
    };

    const root = createRoot(container);
    root.render(
      <React.StrictMode>
        <GuidedProcessTool {...data} />
      </React.StrictMode>
    );
  }
});
export { ProcessData };
